<script setup lang="ts">
import { computed } from 'vue';

import { Btn, Icon } from './index';

const state = defineModel<boolean>({ required: true });

const { size } = defineProps<{ size: number }>();

const emit = defineEmits<{ (e: 'click'): void }>();

const btnStyle = computed<InstanceType<typeof Btn>['style']>(() => ({
  width: `${size * 2}px`,
  height: `${size * 2}px`,
}));
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0 translate-x-4"
    enter-to-class="opacity-100 translate-x-0"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="opacity-100 translate-x-0"
    leave-to-class="opacity-0 translate-x-4"
  >
    <div
      v-if="state"
      class="fixed"
    >
      <Btn
        icon-container
        :style="btnStyle"
        class="border border-[var(--theme-border-subtle)] bg-[var(--theme-control-surface)] shadow-[0_18px_40px_rgba(0,0,0,0.24)]"
        @click="emit('click')"
      >
        <Icon
          name="mingcute:down-fill"
          :width="size"
          :height="size"
        />
      </Btn>
    </div>
  </Transition>
</template>
